module.exports = __webpack_public_path__ + "img/La_Mer_Logo_Green.f4318050.png";